var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BtnBox"},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.btnTigg}},[_vm._v(_vm._s(_vm.btnText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }